module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-header', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/dashboard'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('icon', {
    attrs: {
      "name": "dashboard",
      "scale": "2"
    }
  }), _vm._v("\n        享位平台 - 商户后台\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('nav-panel')], 1)], 1), _vm._v(" "), _c('el-container', [_c('el-aside', {
    style: (_vm.collapse ? 'width:65px' : 'width:250px'),
    attrs: {
      "collapse": _vm.collapse
    }
  }, [_c('menu-panel', {
    ref: "menuPanel",
    staticStyle: {
      "border-top": "1px solid #3d3e3f"
    }
  })], 1), _vm._v(" "), _c('el-main', [_c('div', {
    staticClass: "navLocation",
    attrs: {
      "id": "navTab"
    }
  }, [_c('hamburger', {
    attrs: {
      "isActive": !_vm.collapse,
      "toggleClick": _vm.onToggle,
      "title": "展开或折叠菜单"
    }
  }), _vm._v(" "), _c('el-breadcrumb', _vm._l((_vm.currentNodePaths), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.name
    }, [_vm._v(_vm._s((item.meta || {}).title))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "mainContainer",
      "element-loading-text": "loading ...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.5)"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "defaultRootView",
    attrs: {
      "id": "mainView"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    ref: "defaultRootView",
    attrs: {
      "id": "mainView"
    }
  }) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52533328","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/index.vue
// module id = 336
// module chunks = 0